<template>
  <v-container
    fluid
    v-on="event"
    style="max-width: 19% !important"
    class="d-none align-center justify-space-around d-md-flex"
  >
    <v-menu offset-y open-on-click>
      <template v-slot:activator="{ on }">
        <v-sheet
          class="transparent d-flex align-center justify-space-around"
          width="75%"
        >
          <v-sheet class="transparent d-flex align-center">
            <v-icon color="gray0" v-on="on"> mdi-chevron-down </v-icon>
            <p class="ma-0 mr-2">{{ userName }}</p>
          </v-sheet>
          <v-avatar color="white" size="40" v-on="on"> </v-avatar>
        </v-sheet>
      </template>
      <v-list class="pa-0" width="100%">
        <v-list-item
          v-for="(item, index) in avatarItems"
          :key="index"
          :to="item.src"
          class="menu_list_item"
        >
          <v-list-item-title
            class="text-left d-flex align-center justify-space-around"
          >
            <v-sheet
              class="transparent d-flex align-center justify-center"
              width="18%"
              height="100%"
            >
              <img
                class="list_icon"
                :src="require(`@/assets/images/${item.image}`)"
              />
            </v-sheet>
            <v-sheet
              class="transparent d-flex align-center justify-start pr-4"
              width="75%"
              height="100%"
              @click="$store.dispatch(item?.action)"
            >
              <p class="ma-0" style="cursor: pointer">
                {{ $t(item.title) }}
              </p>
            </v-sheet>
          </v-list-item-title>
          <!-- <custom-list-menu /> -->
        </v-list-item>
      </v-list>
    </v-menu>
    <v-btn icon>
      <v-icon>mdi-bell-outline</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
// import CustomListMenu from "./CustomListMenu.vue";
import { avatarMenu } from "@/assets/static.js";
import { getLocalStorage } from "@/api/localStorage";
export default {
  // components: { CustomListMenu },
  name: "AvatarMenu",
  // props: {
  //   image: String,
  //   title: String,
  //   event: Function,
  // },
  data: () => ({
    avatarItems: avatarMenu,
    userName: JSON.parse(getLocalStorage("user")).name,
  }),
};
</script>

<style>
.list_icon {
  width: 55%;
}
/* .v-menu__content {
  min-width: 12% !important;
  top: 66px !important;
  position: absolute;
  left: 0px !important;
  transform-origin: left top;
  z-index: 8;
} */
</style>
